import { useEffect, useRef, useState } from 'react'
import { loadKakaoMapSdk } from '../lib/kakaoMapSdk'

/**
 * 한 점을 찍어 보여 주는 **카카오맵 한 장**(사용자 결정 2026-08-25).
 *
 * 등록 화면의 「고른 주소 확인」에만 쓴다. **고르거나 옮기는 수단이 아니다** — 그래서
 * 핀을 끌 수 없고 확대·축소도 두지 않는다.
 *
 * 좌표는 지도를 그리는 데만 쓰고 **어디에도 저장하지 않는다** — 좌표는 동 단위 익명화가
 * 원칙이다(설계 원칙 7). 본문에도 싣지 않는다.
 *
 * 키가 없거나 도메인이 콘솔에 등록되지 않았으면 지도가 뜨지 않으므로, 그때는 **자리 자체를
 * 그리지 않는다** — 빈 회색 상자를 남기지 않는다.
 *
 * **높이를 인라인으로 박는다.** FE에서 이 자리가 클래스 이름으로만 높이를 갖고 있다가 그
 * 규칙이 사라져 **높이 0**으로 조용히 안 보인 적이 있다(실측 2026-08-27 — SDK 200 ·
 * canvas 있음 · 컨테이너 높이 0).
 */
export function KakaoPointMap({ lat, lng }: { lat: number; lng: number }) {
  const box = useRef<HTMLDivElement>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true

    loadKakaoMapSdk()
      .then((maps) => {
        if (!alive || box.current === null) return
        const center = new maps.LatLng(lat, lng)
        const map = new maps.Map(box.current, { center, level: 4, draggable: false })
        new maps.Marker({ position: center }).setMap(map)
      })
      .catch(() => {
        if (alive) setFailed(true)
      })

    return () => {
      alive = false
    }
  }, [lat, lng])

  // 지도를 못 그리면 자리도 만들지 않는다 — 주소 자체는 위에 글자로 이미 보인다.
  if (failed) return null

  return (
    <div
      ref={box}
      aria-hidden="true"
      style={{
        marginTop: 8,
        height: 160,
        overflow: 'hidden',
        borderRadius: 10,
        border: '1px solid var(--line, #ddd)',
      }}
    />
  )
}
